import { TD } from "styled/table";

export const ViewRetreadList = ({ tyreData,requestData, index,onSelectionChange,selectedTyres,modalType }) => {

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    onSelectionChange(tyreData._id, checked);
  };

    return (
      <tr key={requestData._id} className={`${index % 2 !== 0 && "bg-gray-100"} h-10`}>
        {modalType !== "tyres" && (
        <TD className="text-center">
          <input
            type="checkbox"
            checked={!!selectedTyres[tyreData._id]}
            onChange={handleCheckboxChange}
          />
        </TD>
      )}
        <TD>{index + 1}</TD>
        <TD>{tyreData?.stencilNo}</TD>
        <TD>{tyreData?.averageNSD}</TD>
        <TD>{tyreData?.brand}</TD>
        <TD>{tyreData?.tyreSize}</TD>
        <TD>{tyreData?.totalKillometerTravelled}</TD>
        <TD>{tyreData?.status ?? tyreData?.oldStatus}</TD>
        {modalType == "tyres" && (
        <TD>{tyreData?.approvedForRetread ? tyreData.rejectedAfterReceiving ? "Rejected After Retread" : "Approved" : "Not Approved"}</TD>
      )}
        <TD>{tyreData?.estimatedCost}</TD>
      </tr> 
    );
  };